export const acessos = [
    'Total',
]